export const initialStateTable = {
  pagination: { pageSize: 10 },
};
export const rowPerPageOptions = [10, 20, 30];

export const maxRecordLength = 1000;
